import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer className="site-footer" data-testid="monumental-footer">
      <div className="site-container footer-top"><div className="footer-brand"><img className="footer-logo" src="/assets/stoneinlove-logo.png" alt="StoneInLove SIL — Travertini Romani / Tivoli" width="827" height="718" loading="lazy" data-testid="footer-logo" /></div><div className="footer-side"><p>Travertini romani d'autore<br />per architetture che restano.</p><a href="#top" className="footer-back-top" data-testid="footer-back-top">Torna in alto <ArrowUpRight size={16} /></a></div></div>
      <div className="site-container footer-bottom"><span>© 2026 Stone In Love S.r.l.s. · P.IVA 16933851004</span><span>Materiali selezionati in Italia / Tivoli, RM</span><a href="#contatti" data-testid="footer-contact-link">Contatti ↗</a></div>
    </footer>
  );
}
